<template>
  <tr>
    <td>{{ extra?.label }}</td>
    <td>
      <toggleswitch
        :labels="true"
        :name="`${extra.id}-enabled`"
        :checked="enabled"
        @change="toggleExtra()"
      ></toggleswitch>
    </td>
    <td>
      <currency-input
        :name="`rates[${rate.charge_id.toString()}][rate]`"
        v-model="rate.rate"
        v-if="rate"
      ></currency-input>
    </td>
    <td>
      <currency-input
        :name="`rates[${rate.charge_id.toString()}][commercial_rate]`"
        v-model="rate.commercial_rate"
        v-if="rate"
      ></currency-input>
    </td>
    <td>
      <currency-input
        :name="`rates[${rate.charge_id.toString()}][max_rate]`"
        v-model="rate.max_rate"
        v-if="rate"
      ></currency-input>
    </td>
    <td>
      <select
        name="charge_type_id"
        class="form-control"
        required
        v-model="rate.charge_type_id"
        v-if="rate"
      >
        <option value="" disabled readonly>
          Please Select
        </option>
        <option
          :value="type.id"
          :key="index"
          v-for="(type, index) in chargeTypes"
        >
          {{ type.label }}
        </option>
      </select>
    </td>
  </tr>
</template>
<script>
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';

export default {
  props: {
    rates: {
      type: Array,
      required: true
    },
    extra: {
      type: Object,
      required: true
    },
    tariff: {
      type: Object,
      required: false
    },
    commercialTariff: {
      type: Object,
      required: false
    },
    selectedTariff: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isEnabled: {
      type: Boolean,
      default: false
    }
  },

  components: {
    CurrencyInput
  },

  computed: {
    commercialRate() {
      const tariffRate = this.commercialTariff?.rates?.find(
        rate => rate.charge_id == this.extra?.id
      );

      return tariffRate?.rate || 0;
    },

    chargeTypes() {
      return this.$store.getters['CreditHireChargeTypes/all'];
    },

    oneOffFee() {
      return this.chargeTypes.find(type => type.name === 'one_off_fee');
    }
  },

  data() {
    return {
      rate: undefined,
      enabled: false
    };
  },

  mounted() {
    // Added a query parameter to identify whether it redirects from 'add' or 'view'.
    const displayParam = this.$route.query.mode;

    if (this.isEnabled && displayParam === 'add') {
      this.toggleExtra();
    }

    let rate = this.rates.find(r => r.charge_id === this.extra.id);

    if (rate) {
      this.enabled = true;
      this.rate = rate;
    }
  },

  methods: {
    toggleExtra() {
      if (this.enabled) {
        const index = this.rates.indexOf(this.rate);

        this.rates.splice(index, 1);

        this.rate = undefined;
        this.enabled = false;
      } else {
        const selectedTariff = Object.keys(this.selectedTariff).length
          ? this.selectedTariff
          : this.tariff;
        const tariffRate = selectedTariff?.rates.find(
          r => r.charge_id === this.extra.id
        );

        const index = this.rates.push({
          charge_id: this.extra.id,
          charge_type_id: tariffRate?.charge_type_id || this.oneOffFee?.id,
          rate: tariffRate?.rate,
          commercial_rate: this.commercialRate,
          max_rate: tariffRate?.max_rate || null
        });

        this.enabled = true;
        this.rate = this.rates[index - 1];
      }
    },

    updateFromTariff() {
      const selectedTariff = Object.keys(this.selectedTariff).length
        ? this.selectedTariff
        : this.tariff;
      if (selectedTariff) {
        const tariffRate = selectedTariff.rates.find(rate => {
          return rate.charge_id == this.extra.id;
        });

        if (tariffRate) {
          const index = this.rates.findIndex(
            rate => rate.charge_id == this.extra.id
          );

          if (index > -1) {
            this.rates[index].rate = tariffRate.rate;
            this.rates[index].commercial_rate = this.commercialRate;
            this.rates[index].max_rate = tariffRate.max_rate;
            this.rates[index].charge_type_id = tariffRate.charge_type_id;
          }
        }
      }
    }
  },

  watch: {
    tariff() {
      this.updateFromTariff();
    }
  }
};
</script>
